//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Object.js";
import "../CAM/CAM.CAMSession.js";
let d=[[[0,"ColorBy",1,0],[0,"DisplayToolPath",1,0],[0,"Option",1,0],[0,"ShowContactPoints",1,0],[0,"ShowCutting",1,0],[0,"ShowEndpoints",1,0],[0,"ShowNoncutting",1,0],[0,"ShowToolCenter",1,0]],[[["opr"],"ShowToolPath",{},1,0],[["opr"],"HideToolPath",{},1,0],[["isFwd"],"Play",{},1,0],[["isFwd"],"Step",{},1,0],[["isFwd"],"StepDisplay",{},1,0],[["isFwd"],"Jump",{},1,0],[["speed"],"SetAnimationSpeed",{},1,0],[["resolution"],"SetIpwResolution",{},1,0],[["type"],"SetToolDisplayType",{},1,0],[["isToolDisplayedInMachine"],"SetDisplayToolInMachine",{},1,0],[["scaleFactor"],"SetToolAxisTraceScale",{},1,0],[["numMotions"],"SetNumberOfMotions",{},1,0]],[]];
SPLM.CAM.PathDisplay = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.CAM.PathDisplay";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.PathDisplay.ColorByType = Object.freeze({
    "MotionType" : "MotionType", "Operation" : "Operation", "Tool" : "Tool", "MotionLength" : "MotionLength", "MotionGeometry" : "MotionGeometry", "Finding" : "Finding", "OperationSelectionState" : "OperationSelectionState", "FeedRateSpikes" : "FeedRateSpikes"});

SPLM.CAM.PathDisplay.ToolDisplayType = Object.freeze({
    "Point" : "Point", "Axis" : "Axis", "Solid" : "Solid", "SolidWithHolder" : "SolidWithHolder", "Assembly" : "Assembly"});

SPLM.CAM.PathDisplay.IpwResolutionType = Object.freeze({
    "Coarse" : "Coarse", "Medium" : "Medium", "Fine" : "Fine"});

SPLM.CAM.PathDisplay.JaCamPathdisplayOption = Object.freeze({
    "All" : "All", "Level" : "Level", "FromStart" : "FromStart", "NextNMotions" : "NextNMotions", "PlusMinusNMotions" : "PlusMinusNMotions"});

export default SPLM;